<template>
  <div>
    <b-container class="pt-3" style="max-height: 95vh; color: rgb(238, 238, 238);">
      <!-- Main Project Buttons -->
      <!-- <div class="menu" v-if="globalIsUserAllowed('Entry_Manager') && !isAdmin">
        <b-row align-v="center">
          <b-col class="optn pl-2">
            <div class="project" @click="$emit('initEntryManager', isAdmin)">
              Entry Manager
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="menu" v-if="globalIsUserAllowed('EOD') && !isAdmin">
        <b-row align-v="center">
            <b-col class="optn pl-2">
              <div class="project" @click="$emit('initEODFieldReviewCarousel')">
                EOD Field Trail Review 
              </div>
            </b-col>
          </b-row>
      </div> -->
      <div v-for="p in projects" :key="p.name" class="menu">
        <b-row v-if="globalIsUserAllowed(p.module_name)" align-v="center"> <!-- TODO: CHECK THIS -->
          <b-col class="optn pl-2" @click="loadLeftNavProject(p)">
            <div class="project">
              {{
                p.name
              }}
            </div>
          </b-col>
          <b-col class="clickable" cols="1" @click="toggleProject(p.name)">
            <fa v-if="projectsWithSubButtons.includes(p.name)"
              :icon="['fas', getProjectToggle(p) ? 'caret-up' : 'caret-down']" size="lg" style="float: left" />
          </b-col>
        </b-row>
        <!-- DPR subnav buttons -->
        <div v-if="p.name == 'Acquisitions' && dprToggle" class="submenu">
          <b-row id="dPREntryManagerRow" v-if="globalIsUserAllowed('DPR')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('loadProject', 'Daily Productivity Report')">
                Daily Productivity Report
              </div>
            </b-col>
          </b-row>
          <b-row id="dPREntryManagerRow" v-if="globalIsUserAllowed('Entry_Manager')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initEntryManager', isAdmin)">
                Entry Manager
              </div>
            </b-col>
          </b-row>
          <b-row v-if="globalIsUserAllowed('DPR_Reports')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initReportConsole')">
                Reports
              </div>
            </b-col>
          </b-row>
          <b-row v-if="globalIsUserAllowed('DPR_Admin_Console')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initAdminConsole')">
                Admin Console
              </div>
            </b-col>
          </b-row>
          <b-row v-if="globalIsUserAllowed('GTP_Tracking')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initGTPModal')">
                GTP Tracking
              </div>
            </b-col>
          </b-row>
          <b-row v-if="globalIsUserAllowed('GTP_Report')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initGTPReportModal')">
                GTP Report
              </div>
            </b-col>
          </b-row>
          <b-row v-if="globalIsUserAllowed('Field_Images')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initImageCarousel')">
                Field Images
              </div>
            </b-col>
          </b-row>
           <b-row v-if="globalIsUserAllowed('EOD')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initEODFieldReviewCarousel')">
                EOD Field Trail Review 
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="menu" v-if="globalIsUserAllowed('Hard_Drive_Tracking_Menu')">
        <b-row align-v="center" @click="toggleProject('Hard Drive Tracking Menu')">
          <b-col class="optn pl-2">
            <div class="project">
              Hard Drive Tracking Menu
            </div>
          </b-col>
          <b-col class="clickable" cols="1">
            <fa :icon="['fas', getProjectToggle('Hard Drive Tracking Menu') ? 'caret-up' : 'caret-down']" size="lg" style="float: left" />
          </b-col>
        </b-row>
        <!-- HDT subnav buttons -->
        <div v-if="hdtToggle" class="submenu">
          <b-row v-if="globalIsUserAllowed('Hard_Drive_Tracking')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('loadProject', 'Hard Drive Tracking')">
                Hard Drive Tracking
              </div>
            </b-col>
          </b-row>
          <b-row v-if="globalIsUserAllowed('HDT_Admin_Console')">
            <b-col class="item">
              <div class="sub-project" @click="$emit('initHDTAdminConsole')">
                Admin Console
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- Vehicle Status button -->
      <div v-if="globalIsUserAllowed('Vehicles')">
        <div class="project-row-padding align-items-center menu pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project" @click="fleetioVehiclesModal()">
              Vehicle Status
            </div>
          </div>
        </div>
      </div>
      <!-- WMS button -->
      <div v-if="globalIsUserAllowed('Work_Management_System')">
        <div class="project-row-padding align-items-center menu pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project" @click="$emit('initWmsModal')">
              Work Management System
            </div>
          </div>
        </div>
      </div>

      <!-- Generic DRT Analtyical Tool -->
      <!-- <div v-if="globalIsUserAllowed('Analytics')" class="menu menu-last" @click="$emit('initAnalytics')">
        <div class="project-row-padding align-items-center pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project">Analytical Tool</div>
          </div>
        </div>
      </div> -->

      <!-- Generic DRT WCL -->
      <div v-if="globalIsUserAllowed('WCL')" class="menu menu-last" @click="$emit('initWCL')">
        <div class="project-row-padding align-items-center pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project">WCL</div>
          </div>
        </div>
      </div>

       <div v-if="globalIsUserAllowed('Data_Tools')" class="menu menu-last" @click="$emit('initDataTool')">
        <div class="project-row-padding align-items-center pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project">Data Tools </div>
          </div>
        </div>
      </div>
      <!-- PTV Menu -->
      <div v-if="globalIsUserAllowed('Sales')" class="menu menu-last" @click="$emit('initSales')">
        <div class="project-row-padding align-items-center pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project">Sales</div>
          </div>
        </div>
      </div>

      <!-- Spatial_Intelligence Menu -->
      <div v-if="globalIsUserAllowed('Spatial_Intelligence')" class="menu menu-last" @click="$emit('initSI')">
        <div class="project-row-padding align-items-center pb-2">
          <div class="clickable col-1"></div>
          <div class="project-name-padding col">
            <div class="project">Spatial Intelligence</div>
          </div>
        </div>
      </div>

      <!-- Ushr Layers Menu Option -->
      <div v-if="homeScreenComponents && ushrLayersVisible && isUshrUser && globalIsUserAllowed('DMP_Layers')"
        @click="toggleUshrLayers" class="menu menu-last">
        <b-row align-v="center" class="project-row-padding pb-2">
          <b-col class="project-name-padding">
            <div class="project">DMP Layers</div>
          </b-col>
          <b-col class="clickable" cols="1">
            <fa :icon="['fas', ushrLayersToggle ? 'caret-up' : 'caret-down']" size="lg" style="float: left" />
          </b-col>
        </b-row>
      </div>

      <!-- Ushr Layers Dynamic Layer List -->
      <div v-if="
        homeScreenComponents &&
        ushrLayersVisible &&
        ushrLayersToggle &&
        isUshrUser &&
        globalIsUserAllowed('DMP_Layers')
      ">
        <b-row align-v="center">
          <MMP_DynamicLayerList class="card-body dynamic-layer-list scroll-Container menu-last"
            :customerProjectId="customerProjectId" :map="map" :mmp_layersObj="mmp_layersObj"
            :showUSHRLayers="ushrLayersVisible" :spinnerManager="spinnerManager"
            :ushrLayersButtonsCtrl="ushrLayersButtonsCtrl" :ushrLayersToggle="ushrLayersToggle" :zoomEnded="zoomEnded"
            :zoomLevelCap="zoomLevelCap" :showLidarPanel="showLidarPanel" :baseMapsOpen="baseMapsOpen"
            :extentsOpen="extentsOpen" @layerButtonsChanged="$emit('layerButtonsChanged', $event)"
            @toggleLayers="toggleUshrLayers()" @toggleLayerVisibility="$emit('toggleLayerVisibility', $event)"
            @toTopOfList="$emit('toTopOfList', $event)" @updateZoomEnded="$emit('updateZoomEnded', $event)">
          </MMP_DynamicLayerList>
        </b-row>
      </div>

      <!-- Customer Layers Menu Option -->
      <div
        v-if="homeScreenComponents && !ushrLayersVisible && globalIsUserAllowed('Customer_Layers')"
        @click="toggleUshrLayers" class="menu menu-last">
        <b-row align-v="center" class="project-row-padding pb-2">
          <b-col class="project-name-padding">
            <div class="project">
              {{ user.role.replace('User', '') }} Layers
            </div>
          </b-col>
          <b-col class="clickable" cols="1">
            <fa :icon="['fas', ushrLayersToggle ? 'caret-up' : 'caret-down']" size="lg"
              :title="ushrLayersToggle ? 'Collapse' : 'Expand'" />
          </b-col>
        </b-row>
      </div>

      <!-- Customer Layers Dynamic Layer List -->
      <div v-if="homeScreenComponents && !ushrLayersVisible && ushrLayersToggle">
        <b-row align-v="center">
          <MMP_DynamicLayerList class="card-body dynamic-layer-list scroll-Container menu-last"
            :customerLayersButtonsCtrl="customerLayersButtonsCtrl" :customerLayersToggle="ushrLayersToggle"
            :customerProjectId="customerProjectId" :cust_layersObj="cust_layersObj" :map="map"
            :mmp_layersObj="mmp_layersObj" :showCustomerLayers="true" :spinnerManager="spinnerManager"
            :zoomEnded="zoomEnded" :zoomLevelCap="zoomLevelCap" :showLidarPanel="showLidarPanel"
            :baseMapsOpen="baseMapsOpen" :extentsOpen="extentsOpen"
            @layerButtonsChanged="$emit('layerButtonsChanged', $event)" @toggleLayers="toggleUshrLayers()"
            @toggleLayerVisibility="$emit('toggleLayerVisibility', $event)" @toTopOfList="$emit('toTopOfList', $event)"
            @updateZoomEnded="$emit('updateZoomEnded', $event)"></MMP_DynamicLayerList>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<style scoped>
.homescreen-project-padding {
  padding-bottom: 25px;
}

.project {
  cursor: pointer;
  font-size: 20px;
}

.project-name-padding {
  padding: 0px 5px;
}

.project-row-padding {
  padding-left: 15px;
  padding-top: 15px;
}

.scroll-Container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.scroll-Container::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.scroll-Container::-webkit-scrollbar-thumb {
  background-color: #797777;
}

.sub-project {
  cursor: pointer;
  font-size: 18px;
  padding-left: 20px;
}


.dynamic-layer-list {
  overflow-y: auto;
  height: auto;
  max-height: 250px;
}

:root {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

* {
  text-decoration: none;
  color: white;
  list-style: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.menu {
  width: 410px;
  height: auto;
  background: rgba(6, 47, 86, 0.1);
  overflow: hidden;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
}

.menu-last {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.menu .optn {
  display: block;
  margin: 12px;
  position: relative;
}

.submenu {
  background: rgba(6, 47, 86, 0.25);
}

.item {
  width: 410px;
  height: auto;
  background: rgba(6, 47, 86, 0.25);
  overflow: hidden;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
  padding: 10px;
  font-size: 18px !important;
}

.item:hover {
  background: rgba(65, 65, 65, 0.4);
}

.menu:hover {
  background: rgba(37, 33, 33, 0.4);
}
</style>
<script>
import MMP_DynamicLayerList from './../shared/MMP_DynamicLayerList.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'MMP_TabNav',
  components: {
    MMP_DynamicLayerList
  },
  computed: {
    ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed'])
  },
  props: [
    'btnClass',
    'customerLayersButtonsCtrl',
    'customerProjectId',
    'cust_layersObj',
    'dprVisible',
    'homeScreenComponents',
    'isAdmin',
    'isUshrUser',
    'layersListMaxHeight',
    'map',
    'mmp_layersObj',
    'projects',
    'spinnerManager',
    'subNavVisible',
    'ushrLayersButtonsCtrl',
    'ushrLayersVisible',
    'user',
    'zoomEnded',
    'zoomLevelCap',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen'
  ],
  data() {
    return {
      dprToggle: false,
      drtToggle: false,
      hdtToggle: false,
      projectsWithSubButtons: [
        'Acquisitions', //'Daily Productivity Report',
        'Hard Drive Tracking'
      ],
      tabIndex: 0,
      ushrLayersToggle: false
    }
  },
  methods: {
    loadLeftNavProject(leftNavProject) {
      if (leftNavProject.name == 'Acquisitions') {
        this.toggleProject(leftNavProject.name)
      } else {
        this.$emit('loadProject', leftNavProject.name)
      }
    },
    getProjectToggle(project) {
      let returnValue = null
      switch (project.name) {
        case 'Daily Productivity Report':
          returnValue = this.dprToggle
          break
        case 'Delivery Review Tool':
          returnValue = this.drtToggle
          break
        case 'Hard Drive Tracking Menu':
          returnValue = this.hdtToggle
          break
      }
      return returnValue
    },
    toggleProject(project) {
      switch (project) {
        case 'Acquisitions':
          this.dprToggle = !this.dprToggle
          break
        case 'Delivery Review Tool':
          this.drtToggle = !this.drtToggle
          break
        case 'Hard Drive Tracking Menu':
          this.hdtToggle = !this.hdtToggle
          break
      }
    },
    loadDefaultLayer(viewCookie) {
      if (viewCookie != undefined && Object.keys(viewCookie).length > 0) {
        let defaultLayers = JSON.parse(viewCookie)
        // Checks if there are any default layers in the cookie
        if (defaultLayers.length > 0) {
          // First for loop runs through default layers in cookie
          for (let layer in defaultLayers) {
            let formattedLayer = defaultLayers[layer]
              .replace(/_/g, ' ')
              .toUpperCase()
            // Second for loop runs through Ushr Layers
            for (let button in this.ushrLayersButtonsCtrl) {
              let formattedButton =
                this.ushrLayersButtonsCtrl[button].name.toUpperCase()
              // If the names match, automatically load that layer on login
              if (formattedLayer == formattedButton) {
                this.$emit(
                  'toggleLayerVisibility',
                  this.ushrLayersButtonsCtrl[button].name
                )
              }
            }
          }
        }
      }
    },
    toggleUshrLayers() {
      this.ushrLayersToggle = !this.ushrLayersToggle
    },
    custLayerToggle(layerNameToToggle) {
      if (this.cust_layersObj[layerNameToToggle] != null) {
        let layerobj = this.cust_layersObj[layerNameToToggle].layer
        if (this.checkLayer(layerobj)) {
          this.map.removeLayer(layerobj)
          this.$emit('showCustomerLayer', false)
        } else {
          this.map.addLayer(layerobj)
          this.$emit('showCustomerLayer', true)
        }
      }
    },
    custBtnClass(layerName) {
      let returnClass
      let layerobj = this.cust_layersObj[layerName].layer
      !this.checkLayer(layerobj)
        ? (returnClass = 'dark')
        : (returnClass = 'primary')
      return returnClass
    },
    checkLayer(layerobj) {
      let tileLayers = this.map
        .getLayers()
        .getArray()
        .filter(function (layer) {
          return layer.getSource() && layer.getSource().getTileGrid
        })
      let exists = tileLayers.indexOf(layerobj) !== -1
      return exists
    },
    fleetioVehiclesModal() {
      this.$bvModal.show('fleetioVehiclesModal')
    }
  },
  mounted() {
    this.$emit('onResize')
    this.$emit('mainMenuSizeChange')
    this.loadDefaultLayer(sessionStorage.View)
  },
  updated() {
    this.$emit('mainMenuSizeChange')
  },
  watch: {
    cust_layersObj: function (newValue, oldValue) {
      this.cust_layersObj = newValue
    },
    customerLayersButtonsCtrl: function (newValue, oldValue) {
      this.customerLayersButtonsCtrl = newValue
    }
  }
}
</script>
